import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Benefits from "../components/Benefits";
import Marquee from "../components/Marquee";
import Testimonials from "../components/Testimonials";
import RegistrationForm from "../components/RegistrationForm";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="bg-black text-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Benefits />
        <Marquee />
        <Testimonials />
        <RegistrationForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default LandingPage;
